import { render } from "./TermsConditions.vue?vue&type=template&id=5205ad4f&scoped=true"
import script from "./TermsConditions.vue?vue&type=script&lang=js"
export * from "./TermsConditions.vue?vue&type=script&lang=js"

import "./TermsConditions.vue?vue&type=style&index=0&id=5205ad4f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5205ad4f"]])

export default __exports__